// Deep-import the CJS build; transliteration's `browser` field points at a
// script-tag UMD that does not expose CJS exports.
import { transliterate } from 'transliteration/dist/node/src/node';
import getSlug from 'speakingurl';

// Fall back to Unicode transliteration only when speakingurl produces an empty
// slug (e.g. Hangul, Kana and other scripts it does not map).
export const slugify = (input: string | null | undefined): string => {
  const value = input || '';
  return getSlug(value) || getSlug(transliterate(value));
};
